var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNshift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.nshift{fill:#0016A3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "nshift",
    d: "M35,10.4c-12.7,0-23,10.3-23,23v1.7h11.4v-1.7c0-6.4,5.2-11.6,11.6-11.6S46.6,27,46.6,33.4v26.2H58V33.4 C58,20.7,47.7,10.4,35,10.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 57.9,
    className: "nshift",
    width: 11.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 51.3,
    className: "nshift",
    width: 11.4,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44.5,
    className: "nshift",
    width: 11.4,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36.9,
    className: "nshift",
    width: 11.4,
    height: 5.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNshift);
export default __webpack_public_path__ + "static/media/nshift.c731e56abc7474ec03bab68d2a742436.svg";
export { ForwardRef as ReactComponent };